<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row v-if="userRole !== 'user'">
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" class="pull-right" @click="$router.push('/admin/gebruikers/toevoegen')">
              Gebruiker toevoegen
            </b-button>
          </b-col>
        </b-row>
        <resource-index endpoint="users" show-route="users.view" add-route="users.create" header="Beheerders"></resource-index>
      </div>
    </div>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';

export default {
  name: 'users',
  components: { ResourceIndex },
  computed: {
    userRole() {
      return this.$store.state.userRole
    }
  },
}

</script>
